import {
  takeLatest,
  put,
  select,
} from 'redux-saga/effects';
import baseSelector from './selectors';
import * as types from './types';

function* setCurrentCode({ index }) {
  const { errorCodeSelected, currentErrorCode } = yield select(baseSelector);
  if (!errorCodeSelected.includes(currentErrorCode)) {
    const len = errorCodeSelected.length;
    yield put({
      type: types.SET_CURRENT_ERROR_CODE,
      currentErrorCode: index >= len ? errorCodeSelected[len - 1] : errorCodeSelected[index],
    });
  }
}

function* watchRemoveErrorCode() {
  yield takeLatest([
    types.REMOVE_ERROR_CODE,
  ], setCurrentCode);
}

export default [
  watchRemoveErrorCode,
];
